import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskDeleteApiOptions {
  taskId: number
  onStart?: () => void
  onFinish?: () => void
}

/** `DELETE /admin-api/tutor-tasks/{task}`. A task with a progress report is refused with a 422. */
export const useTutorTaskDeleteApi = async (options: TutorTaskDeleteApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-task.delete', { task_id: options.taskId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.delete<ApiResponse>(url)
    toast.success('The task was successfully delete.')

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
